import * as React from 'react';

import { ProtocolsLocale } from './protocols.locale';
import SectionTitle from '../../SectionTitle/SectionTitle';

interface ProtocolsProps {
  locale: ProtocolsLocale;
}

const Protocols: React.SFC<ProtocolsProps> = ({ locale }) => (
  <>
    <SectionTitle>{locale.title}</SectionTitle>
    <div className="row mt-5">
      {locale.list.map((item, index) => (
        <div key={index} className="col-12 col-lg-4 mb-3 mb-lg-0">
          {item}
        </div>
      ))}
    </div>
  </>
);

export default Protocols;



// WEBPACK FOOTER //
// /www/client/src/components/TechnicalPage/Protocols/Protocols.tsx